import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AuthComponent from './AuthComponent';
import MainComponent from './MainComponent';
import PrivateRoute from './PrivateRoute';
import ProjectList from './ProjectList';
import ParentComponent from './ParentComponent';
import TestComponent from './TestComponent';
import TestScriptProcessor from './TestScriptProcessor';
import TestProcessorWorklet from './TestProcessorWorklet';
import GuestComponent from './GuestComponent';
import PasswordResetForm from './PasswordResetForm';

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/login" element={<AuthComponent />} />
                <Route path="/reset-password/:token" element={<PasswordResetForm />} />
                <Route path="/projects" element={<PrivateRoute element={ProjectList} />} />
                <Route path="/" element={<PrivateRoute element={MainComponent} />} />
                <Route path="/guest" element={<GuestComponent />} />
                <Route path="/test" element={<TestComponent />} />
                <Route path="/script" element={<TestScriptProcessor />} />
                <Route path="/worklet" element={<TestProcessorWorklet />} />
            </Routes>
        </Router>
    );
}

export default App;
